import axios from 'axios';
import router from '../Router/index';
export default {
  namespaced: true,
  state: {
    members_id: [],
    students_id: [],
    students: [],
    members: [],
    workers: [],
    workers_id: [],
    workers_list: [],
    users: [],
    users_id: [],
    user: {},
    users_ids_permit: [],
    user_rep: {}
  },
  getters: {},
  mutations: {
    SET_USER(state, value) {
      state.user = value;
    },
    SET_USER_REP(state, value) {
      state.user_rep = value;
    },
    FILTER_AND_REMOVE_USERS(state, user_id) {
      state.users = state.users.filter(member => member.user_id !== user_id);
    },
    FILTER_AND_REMOVE_WORKER_LIST(state, user_id) {
      state.workers_list = state.workers_list.filter(
        member => member.user_id !== user_id
      );
    },
    FILTER_AND_REMOVE_USERS_ID(state, user_id) {
      state.users_id = state.users_id.filter(member => member !== user_id);
    },
    FILTER_AND_REMOVE_MEMBER(state, user_id) {
      state.members = state.members.filter(
        member => member.user_id !== user_id
      );
    },
    FILTER_AND_REMOVE_WORKERS(state, user_id) {
      state.workers = state.workers.filter(
        member => member.user_id !== user_id
      );
    },
    FILTER_AND_REMOVE_WORKERS_ID(state, user_id) {
      state.workers_id = state.workers_id.filter(member => member !== user_id);
    },
    FILTER_AND_REMOVE_MEMBER_ID(state, user_id) {
      state.members_id = state.members_id.filter(member => member !== user_id);
    },
    SET_MEMBERS_ID(state, value) {
      state.members_id = value;
    },
    SET_WORKERS_ID(state, value) {
      state.workers_id = value;
    },
    SET_WORKERS_LIST(state, value) {
      state.workers_list = value;
    },

    SET_USERS(state, value) {
      state.users = value;
    },
    SET_USERS_ID(state, value) {
      state.users_id = value;
    },
    SET_USERS_IDS_PERMIT(state, value) {
      state.users_ids_permit = value;
    },
    SET_WORKERS(state, value) {
      state.workers = value;
    },
    PYSH_MEMBERS_ID(state, value) {
      state.members_id.push(value);
    },
    SET_MEMBERS(state, value) {
      state.members = value;
    },

    PYSH_MEMBERS(state, value) {
      state.members.push(value);
    },
    PYSH_WORKERS_LIST(state, value) {
      state.workers_list.push(value);
    },
    PYSH_WORKERS(state, value) {
      state.workers.push(value);
    },
    PYSH_WORKERS_ID(state, value) {
      state.workers_id.push(value);
    },
    PYSH_USERS(state, value) {
      state.users.push(value);
    },
    PYSH_USERS_ID(state, value) {
      state.users_id.push(value);
    },

    FILTER_AND_REMOVE_STUDENTS(state, user_id) {
      state.students = state.students.filter(
        member => member.user_id !== user_id
      );
    },
    FILTER_AND_REMOVE_STUDENTS_ID(state, user_id) {
      state.students_id = state.students_id.filter(
        member => member !== user_id
      );
    },
    SET_STUDENTS_ID(state, value) {
      state.students_id = value;
    },
    PYSH_STUDENTS_ID(state, value) {
      state.students_id.push(value);
    },
    SET_STUDENTS(state, value) {
      state.students = value;
    },
    PYSH_STUDENTS(state, value) {
      state.students.push(value);
    }
  },
  actions: {}
};
